import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Button, Spin, Tooltip } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import clsx from 'clsx';
import { useFormikContext } from 'formik';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { useStepper } from '../../context';
import { fieldsByStep } from '../../form';
import type { NewBankAccount } from '../../form';

const SUMMARY_STEP = 4;

function Footer() {
  const { currentStep, nextStep } = useStepper();
  const history = useHistory();
  const { values, dirty, errors, status, handleSubmit, isSubmitting } = useFormikContext<NewBankAccount>();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const isCrossborder = user?.international_account || user?.crossborder;

  const hasSubmitted = status === 'submitted';
  const hasVerified = status === 'verified';
  const isSubmitStep = currentStep === SUMMARY_STEP;

  function getStepFieldError(fields: string[]) {
    return Object.entries(errors)
      .find(([key]) => fields.includes(key))
      ?.pop();
  }

  function getButtonTitle() {
    if (isSubmitStep) return 'Enviar';
    if (hasSubmitted) return 'Verificar código';
    if (hasVerified) return 'Finalizar';
    return 'Continuar';
  }

  function getButtonClickHandler() {
    if (isSubmitStep || hasSubmitted) return () => handleSubmit();
    if (hasVerified) return () => history.push('/producer/profile/bankdata');
    return nextStep;
  }

  const stepFields = fieldsByStep[isCrossborder ? 'crossborder' : 'national'][currentStep - 1];
  const hasFieldsInStep = !!stepFields?.length;
  const errorMessage = hasFieldsInStep && getStepFieldError(stepFields);
  const shouldDisableBtn = (!dirty && !values.id) || !!errorMessage;

  return (
    <footer className='flex flex-col items-start'>
      <Tooltip title={String((shouldDisableBtn ? errorMessage : '') || '')} placement='top'>
        <span>
          <Button
            id='step-submit-btn'
            htmlType='submit'
            disabled={isSubmitting}
            icon={isSubmitting ? <Spin size='small' /> : undefined}
            className={clsx(
              'mb-8',
              shouldDisableBtn && 'border-outline-disabled bg-surface-disabled text-content-disabled cursor-not-allowed'
            )}
            onClick={shouldDisableBtn ? undefined : getButtonClickHandler()}
            type='primary'
          >
            {!isSubmitting ? getButtonTitle() : 'Enviando...'} <Icon.ArrowRight size={24} className='size-6 text-2xl'  />
          </Button>
        </span>
      </Tooltip>
    </footer>
  );
}

export { Footer };
